module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/avatars/team-1-3a6c0fe2e6ac0703653c48f7f932abb4.jpg";